import { makeStyles } from '@mui/styles';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        padding: '0 1rem',
        marginTop: '1.5rem',
        marginBottom: '1.5rem'
    },
    selectContainer: { marginTop: '1rem' },
    select: { margin: '.25rem 25% 0 .25rem' },
    detailRow: {
        flexBasis: 'auto' as const,
        padding: '.75rem .3rem',
        borderBottom: `1px solid ${theme?.app?.applicationColors.enumColors.grey ||
        '#888888'}`,
        '&:first-child': { paddingTop: 0 }
    },
    labelFont: { fontSize: '14px' },
    valueFont: { fontSize: '12px' },
    tableRow: { marginBottom: '.3rem' },
    tableLabelCell: {
        backgroundColor: theme?.app?.applicationColors.tableRowLabelColor ||
            'rgba(185, 217, 236,5)',
        fontWeight: 'bold' as const,
        fontSize: '.875rem'
    },
    tableCell: {
        border: 'none' as const,
        paddingTop: '.3rem',
        paddingBottom: '.3rem'
    }
}));